



<section class="main-home">
    <div class="wrapper" *ngIf="isData">
        <home-slider [slides]='slides'></home-slider>
        <comp-video></comp-video>
        <about-section></about-section>
        <our-portfolio ></our-portfolio>
        <our-services></our-services>
        <our-clients></our-clients>        
    </div>
    <app-loader [loader]='isLoading'></app-loader>
</section>


